import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { BUTTON_COLORS } from 'shared/constants';

/**
 * @param {Object} props
 * @param {string|Object} props.message
 * @param {boolean} props.isOpen
 * @param {Function} props.denyCallback
 * @param {string} [props.title='Alert']
 * @param {string} [props.acceptBtnText='Accept']
 * @param {Function} [props.acceptCallback]
 * @param {string} [props.denyBtnText='Back']
 * @param {string} [props.primaryBtnColor] - One of: 'primary', 'secondary', 'error',
 *   'warning', 'info', 'success'
 */
export default function UserPrompt({
  message,
  title = 'Alert',
  acceptBtnText = 'Accept',
  acceptCallback = () => console.error('must implement acceptCallback()'),
  denyBtnText = 'Back',
  denyCallback,
  isOpen,
  primaryBtnColor = BUTTON_COLORS.primary,
}) {
  return (

    // Escape, backdrop and a reflexive Enter all deny: this prompt guards deletes.
    <Dialog
      open={isOpen}
      onClose={denyCallback}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText component="span" id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={denyCallback} autoFocus>{denyBtnText}</Button>
        <Button color={primaryBtnColor} variant="contained" onClick={acceptCallback}>
          {acceptBtnText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
